<template>
  <el-container class="main-container">
    <!-- 顶部导航 -->
    <div class="content-wrapper">
      <!-- 视频背景横幅 -->
      <section class="hero">
        <video v-if="showType===0" autoplay muted loop playsinline class="video-bg">
          <source src="https://cnscf.oss-cn-beijing.aliyuncs.com/sourcematerial/20250625181436fdbfa19ae1474e0794785cfc87f158e9.mp4" type="video/mp4" preload="auto"/>
        </video>
        <img v-if="showType===1" src="https://cnscf.oss-cn-beijing.aliyuncs.com/sourcematerial/20250630115116bb976658a56b42a19159f23b435e4e7b.png" class="video-bg"></img>
        <div class="hero-text">
          <h2 class="slogan">{{ t('slogan') }}</h2>
          <span class="learn-more">{{ t('learnMore') }}</span>
        </div>
      </section>

      <!-- 产品主推轮播图 -->
      <section class="featured-product">
        <div class="carousel-wrapper">
          <el-carousel :height="carouselHeight" :interval="3000" arrow="hover">
            <el-carousel-item v-for="(item, index) in carouselImages" :key="index">
              <img :src="item" class="carousel-img" />
            </el-carousel-item>
          </el-carousel>
          <div class="product-text">
            <h2 class="product-text-slogan">{{ t('productText') }}</h2>
            <h2 class="product-text-slogan1">{{ t('productText1') }}</h2>
            <span class="learn-more1">{{ t('learnMore') }}</span>
          </div>
        </div>
      </section>

      <!-- 产品列表 -->
      <section class="product-list">
        <h2>{{ t('exploreProducts') }}</h2>
        <el-row :gutter="20" type="flex" justify="center">
          <el-col :span="10" class="product-col">
            <router-link :to="{ name: 'ProductSearch', params: { type: modelList[0].type } }" class="a-style">
              <img :src="modelList[0].modelPicurl" class="product-image" />
            </router-link>
          </el-col>
          <el-col :span="10" class="product-col">
            <router-link :to="{ name: 'ProductSearch', params: { type: modelList[1].type } }" class="a-style">
              <img :src="modelList[1].modelPicurl" class="product-image" />
            </router-link>
          </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" class="product-row" >
          <el-col :span="10" class="product-col">
            <router-link :to="{ name: 'ProductSearch', params: { type: modelList[2].type } }" class="a-style">
              <img :src="modelList[2].modelPicurl" class="product-image" />
            </router-link>
          </el-col>
          <el-col :span="10" class="product-col">
            <router-link :to="{ name: 'ProductSearch', params: { type: modelList[3].type } }" class="a-style">
              <img :src="modelList[3].modelPicurl" class="product-image" />
            </router-link>
          </el-col>
        </el-row>
      </section>
    </div>
  </el-container>
</template>

<script>
import {listModelManager, listVideoManager} from '@/utils/http'

export default {
  name: "App",
  props: ['t', 'currentLang'],
  data() {
    return {
      currentLang: 'zh',
      flagCn: 'https://flagcdn.com/w40/cn.png',
      flagEn: 'https://flagcdn.com/w40/gb.png',
      params:{
        eType:0,
        type:0
      },
      videoInfo:[],
      modelList:[],
      carouselImages: [
        'https://cnscf.oss-cn-beijing.aliyuncs.com/sourcematerial/202506301505353e47e854218049caa1623ba44f893e69.jpg',
        'https://cnscf.oss-cn-beijing.aliyuncs.com/sourcematerial/20250625181840fa08a9f2277f4df783c09b34e817bbfd.jpg',
        'https://cnscf.oss-cn-beijing.aliyuncs.com/sourcematerial/202506251818574d15ad2797c840e7ba2116b12c3d8467.jpg'
      ],
      carouselHeight: '960px',
      showType:0
    };
  },
  mounted() {
    this.updateCarouselHeight();
    window.addEventListener('resize', this.updateCarouselHeight);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateCarouselHeight);
  },
  created() {
    this.getVideoInfo();
    this.getModelList();
  },
  methods: {
    getVideoInfo(){
      listVideoManager(this.params).then(response => {
        this.videoInfo=response.rows;
      })
    },
    getModelList(){
      listModelManager(this.params).then(response => {
        this.modelList=response.rows;
      })
    },
    updateCarouselHeight() {
      const width = window.innerWidth;
      console.log(width)
      if (width <= 480) {
          this.showType = 1;
        } else if (width <= 768) {
          this.showType = 1;
        } else if (width <= 1024) {
          this.showType = 0;
        }else if(width<=1920){
          this.showType = 0;
        } else {
          this.showType = 0;
        }
      // if (width <= 480) {
      //   this.carouselHeight = '200px';
      // } else if (width <= 768) {
      //   this.carouselHeight = '300px';
      // } else if (width <= 1024) {
      //   this.carouselHeight = '600px';
      // }else if(width<=1920){
      //   this.carouselHeight = '960px';
      // } else {
      //   this.carouselHeight = '2160px';
      // }
      this.carouselHeight=width/2+'px';
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none !important;
}
.el-menu--horizontal > .el-menu-item:hover {
  border-bottom: none !important;
}
.app {
  background: #0d0d0d;
  color: #fff;
}

/* 轮播图样式 */
.carousel-wrapper {
  width: 100%;
  margin: 0 auto;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* 容器样式 */
.main-container {
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
}

.content-wrapper {
  width: 100%;
  margin: 0 auto;
}

/* 视频横幅样式 */
.hero {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 840px;
  overflow: hidden;
}

.video-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.hero-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
  color:#FFFFFF;
  z-index: 2;
}

.product-text {
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
  color:#FFFFFF;
  z-index: 2;
}

.slogan {
  font-family: 'ZCOOL KuaiLe', cursive;
  font-size: 45px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}

.product-text-slogan {
  font-size: 80px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
}


.product-text-slogan1 {
  font-size: 20px;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  margin-top:-50px;
}
.learn-more {
  font-family: 'ZCOOL KuaiLe', cursive;
  text-decoration: underline;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

.learn-more1 {
  font-family: 'ZCOOL KuaiLe', cursive;
  text-decoration: underline;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.5);
}

.featured-product {
  text-align: center;
  width: 100%;
  margin: 0 auto;
}

/* 产品列表样式 */
.product-list {
  text-align: center;
  background-color: #262A30;
  padding: 50px 10%;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
}

.product-image {
  width: 100%;
  max-width: 100%;
  height: auto;
}

.product-row {
  margin-top: 30px;
}

/* 超大屏适配 */
@media screen and (min-width: 2560px) {

  .carousel-img {
    object-fit: fill; /* 确保图片填满整个空间 */
  }

  .product-text-slogan {
    font-size: 60px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  }


  .product-text-slogan1 {
    font-size: 20px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-50px;
  }

  .hero-text .slogan {
    font-size: 60px;
  }

  .hero-text .learn-more {
    font-size: 40px;
  }

  .learn-more1 {
    font-size: 40px;
  }

  .product-list h2 {
    font-size: 50px;
  }
}
@media screen and (min-width: 3840px) {  /* 4K分辨率 */
  .hero-text .slogan {
    font-size: 120px;
  }

  .product-text-slogan {
    font-size: 120px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  }


  .product-text-slogan1 {
    font-size: 40px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-50px;
  }

  .hero-text .learn-more {
    font-size: 60px;
  }
  .learn-more1 {
    font-size: 60px;
  }

  .product-list h2 {
    font-size: 75px;
  }
}
@media screen and (min-width: 5120px) {  /* 5K分辨率及以上 */
  .hero-text .slogan {
    font-size: 160px;
  }

  .learn-more {
    font-size: 80px;
  }

  .learn-more1 {
    font-size: 80px;
  }

  .product-list h2 {
    font-size: 100px;
  }

  .product-text-slogan {
    font-size: 360px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  }


  .product-text-slogan1 {
    font-size: 100px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-180px;
  }
}
/* 移动端样式 */
@media screen and (max-width: 768px) {
  .hero {
    height: 500px;
    min-height: auto;
  }

  .hero-text {
    width: 90%;
  }
  .product-row{
    margin-top:0px;
  }
  .slogan {
    font-size: 28px;
    margin-bottom: 15px;
  }

  .product-text-slogan {
    font-size: 28px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
  }


  .product-text-slogan1 {
    font-size: 18px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-180px;
  }

  .learn-more {
    font-size: 16px;
  }

  .product-list {
    padding: 30px 5%;
  }

  .product-col {
    width: 45% !important;
    max-width: 200px;
    flex: 0 0 auto !important;
  }

  .el-row {
    flex-wrap: wrap;
  }

  .el-col {
    margin-bottom: 20px;
    width: 100%;
  }
}

/* 小屏幕手机调整 */
@media screen and (max-width: 480px) {
  .hero {
    height: 200px;
  }

  .slogan {
    font-size: 24px;
  }
  .product-text-slogan {
    font-size: 24px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-5px;
  }


  .product-text-slogan1 {
    font-size: 10px;
    text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
    margin-top:-20px;
  }

  .learn-more1{
    font-size:8px;
  }
  .product-row{
    margin-top:0px;
  }


  .product-col {
    width: 100% !important;
    max-width: 300px;
    margin: 0 auto 20px;
  }
}
</style>
